import { GET_FLOOR_CMS_API } from '../commons/constants';
import { FloorTypes } from '../types';
import { PaginationResponseTypes } from '../types/response';
import { get } from './axios';

export const fetchFloorsCms = async (request: {
  keyword?: string;
  projectId?: string | number;
  projectItemIds?: string;
}): Promise<PaginationResponseTypes<FloorTypes[]>> => {
  let res: any;
  try {
    res = await get(`${GET_FLOOR_CMS_API}`, { params: { ...request } });
  } catch (e) {
    console.error(e);
    return null;
  }
  return res;
};
